export default __webpack_public_path__ + "a6ffb632389294c2321c71e6a7ce192f.svg";